import Vue from "vue";
import VueRouter from "vue-router";

import WhereToBuyMap from "@Scripts/Components/WhereToBuy/WhereToBuyMap.vue";
import SectionList from "@Scripts/Components/MyBremboParts/FileSharing/Section/SectionList.vue";
import SectionProductImages from "@Scripts/Components/MyBremboParts/FileSharing/Section/SectionProductImages.vue";
import ShareTokenList from "@Scripts/Components/MyBremboParts/FileSharing/ShareToken/ShareTokenList.vue";
import SectionDetail from "@Scripts/Components/MyBremboParts/FileSharing/Section/SectionDetail.vue";

Vue.use(VueRouter);

export const router = new VueRouter({
    mode: "history",
    routes: [
        { name: "WhereToBuyMap", path: "/:region/:language/where-to-buy", component: WhereToBuyMap, props: true },
        { name: "IntroFileSharing", path: "/:region/:language/mybremboparts/filesharing", redirect: { name: "SectionList" } },
        { name: "SectionList", path: "/:region/:language/mybremboparts/filesharing/sections", component: SectionList, props: true },
        { name: "SectionProductImages", path: "/:region/:language/mybremboparts/filesharing/sections/productimages", component: SectionProductImages, props: true },
        { name: "ShareTokenList", path: "/:region/:language/mybremboparts/filesharing/sections/sharetokens", component: ShareTokenList, props: true },
        { name: "SectionDetail", path: "/:region/:language/mybremboparts/filesharing/sections/:sectionName", component: SectionDetail, props: true }
    ]
});